import { type IOperator } from '@entities/operator';
import { type IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';
import { type Hotel } from '@entities/hotel/@/tourProduct';
import { type IRawRoom } from '@entities/room';
import { type TourProduct as ITourProduct } from '../types/ITourProduct';
import { type IRawTourProduct } from '../index';
import { FlightType } from '../types/IFlightType';
import { HotelAvailable } from '../types/IHotelAvailable';

export default class TourProduct implements ITourProduct {
    rawTourProduct: IRawTourProduct;

    id: string;

    price: number;

    oilTax: number | null;

    hotelAvailable: HotelAvailable;

    medicalInsurance: boolean;

    transferType: ITourProduct['transferType'];

    hotel: Hotel | null = null;

    operator: IOperator | null = null;

    touristGroup: ITourProduct['touristGroup'] = null;

    country: ITourProduct['country'] = null;

    room: IRawRoom | null = null;

    availableTransfers: ITourProduct['availableTransfers'] = [];

    firstPaymentDefinitions: IFirstPaymentDefinition[] = [];

    constructor(rawTourProduct: IRawTourProduct) {
        this.rawTourProduct = rawTourProduct;
        this.id = rawTourProduct.id;
        this.price = rawTourProduct.price;
        this.oilTax = rawTourProduct.oilTax;
        this.hotelAvailable = rawTourProduct.hotelAvailable;
        this.medicalInsurance = rawTourProduct.medicalInsurance;
        this.transferType = rawTourProduct.transferType;
    }

    get flightType(): FlightType {
        return this.rawTourProduct.flightType === 'regular' ? FlightType.regular : FlightType.charter;
    }

    get priceWithOilTax(): number {
        return (this.oilTax || 0) + this.price;
    }

    setHotel(hotel: Hotel | null): void {
        this.hotel = hotel;
    }

    setOperator(operator: IOperator | null): void {
        this.operator = operator;
    }

    setRoom(room: IRawRoom | null): void {
        this.room = room;
    }

    setFirstPaymentDefinitions(definitions: IFirstPaymentDefinition[]): void {
        this.firstPaymentDefinitions = definitions;
    }
}
